const initializeBootstrapTooltips = () => {
  const scrollContainer = document.getElementById('admin-scroll-container');

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

  tooltipTriggerList.map(function (tooltipTriggerEl) {
    if (bootstrap.Tooltip.getInstance(tooltipTriggerEl)) return null;
    return new bootstrap.Tooltip(tooltipTriggerEl, { container: scrollContainer, boundary: scrollContainer });
  });

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.map(function (popoverTriggerEl) {
    if (bootstrap.Popover.getInstance(popoverTriggerEl)) return null;
    return new bootstrap.Popover(popoverTriggerEl, { container: scrollContainer, boundary: scrollContainer });
  });
};

module.exports = initializeBootstrapTooltips;
